import React, { Component } from "react";
import footerTheme from "css/themes/mobile/footer.css";
import EmailCollector from "login/visual-components/util/email-collector";
import { Col, Grid, Row } from "react-flexbox-grid";
import { H1, P } from "visual-components/util/texts";

export default class MobileGrowSection extends Component {
  render() {
    return (
      <div className={footerTheme.mobileGrowSection}>
        <Grid>
          <Row center="xs">
            <Col xs>
              <H1 white>Ready to Grow?</H1>
            </Col>
          </Row>
          <Row
            center="xs"
            style={{
              marginTop: "16px",
            }}
          >
            <Col xs>
              <P white>Apply Now to Get Access!</P>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs>
              <EmailCollector isMobile buttonText="Apply Now" />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
